"use strict";var _interopRequireDefault=require("@babel/runtime/helpers/interopRequireDefault");var _styledComponents=_interopRequireDefault(require("styled-components"));Object.defineProperty(exports,"__esModule",{value:!0}),exports.ContactInfoChipsContainer=exports.ChipContainer=void 0;const ChipContainer=exports.ChipContainer=_styledComponents.default.div`
    display: flex;
    border: 1px solid #c8c7cc;
    border-radius: 38px;
    padding: 0.2rem 0.5rem;
    margin: 0.5rem 0;

    .call-icon {
        align-self: center;
        width: 15px;
        height: 15px;
    }

    .contact-info {
        align-self: center;
    }
`,ContactInfoChipsContainer=exports.ContactInfoChipsContainer=_styledComponents.default.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: 0.5rem 0;
`;